import React from "react";
import { chipFields, formatField, timestampField } from "../function";
import { PencilIcon, PendingIcon, fieldIcon } from "./Icons";

const PILL_CLASS = {
  active: "ds-pill ds-pill-active",
  inactive: "ds-pill ds-pill-inactive",
  unset: "ds-pill ds-pill-unset",
};

const PILL_LABEL = {
  active: "Active",
  inactive: "Inactive",
  unset: "Not set",
};

// One section of one device. The whole cell is the edit button.
//
// It renders `current` - what the device reports - and nothing else. A queued
// change is announced by the Pending badge rather than shown as a value, so the
// table never claims the device is running a schedule it has not applied.
function SyncCell({ section, cell, onEdit, saving, offline = false }) {
  const { current, status, pending } = cell;
  const stamp = timestampField(section);
  const updated = stamp ? formatField(stamp, current) : null;

  return (
    <button
      type="button"
      className="ds-cell"
      onClick={onEdit}
      disabled={saving}
      title={saving ? "Saving..." : `Edit ${section.label}`}
    >
      <div className="ds-cell-head">
        {saving ? (
          <span className="ds-pill ds-pill-saving">Saving...</span>
        ) : (
          <span className={PILL_CLASS[status]}>{PILL_LABEL[status]}</span>
        )}

        {pending && !saving && (
          <span
            className="ds-badge-pending"
            title={
              offline
                ? "Sent, but the device is offline - it will apply this when it comes back online"
                : "Sent to the device, not applied yet"
            }
          >
            <PendingIcon />
            Pending
          </span>
        )}

        <span className="ds-edit-hint">
          <PencilIcon />
        </span>
      </div>

      <div className="ds-chips">
        {chipFields(section).map((field) => {
          const Icon = fieldIcon(field.type);
          const value = formatField(field, current);

          return (
            <span className="ds-chip" key={field.name}>
              <Icon />
              <span className="ds-chip-label">{field.label}</span>
              <span className={value ? "" : "ds-chip-empty"}>
                {value || "Not set"}
              </span>
            </span>
          );
        })}
      </div>

      <div className="ds-stamp">
        {updated ? `Updated ${updated}` : "No update reported"}
      </div>
    </button>
  );
}

export default SyncCell;
